export default "__VITE_ASSET__DqIk3MqF__"